import {call, put, takeLatest} from 'redux-saga/effects';
import {
  // get chat messages
  getChatMessagesRequest,
  getChatMessagesSuccess,
  getChatMessagesFailure,

  // send chat message
  sendChatMessageRequest,
  sendChatMessageSuccess,
  sendChatMessageFailure,
} from '../slices/chatSlice';

import {getChatMessages, sendChatMessage} from '@/services/api';
import {SUCCESS_KEY} from '@/constants';

function* GetChatMessagesSaga(action: any): Generator {
  try {
    const response: any = yield call(getChatMessages, action.payload);
    const {id: consultation_id} = action.payload;
    if (response.data.status === SUCCESS_KEY) {
      yield put(getChatMessagesSuccess(response.data));
    } else {
      yield put(getChatMessagesFailure({...response.data, data: {consultation_id}}));
    }
  } catch (error: any) {
    yield put(getChatMessagesFailure(error.response));
  }
}

function* SendChatMessageSaga(action: any): Generator {
  try {
    const response: any = yield call(sendChatMessage, action.payload);
    const {id: consultation_id} = action.payload;
    if (response.data.status === SUCCESS_KEY) {
      yield put(sendChatMessageSuccess(response.data));
    } else {
      yield put(sendChatMessageFailure({...response.data, data: {consultation_id}}));
    }
  } catch (error: any) {
    yield put(sendChatMessageFailure(error.response));
  }
}

export default function* ChatSaga(): Generator {
  yield takeLatest(getChatMessagesRequest.type, GetChatMessagesSaga);
  yield takeLatest(sendChatMessageRequest.type, SendChatMessageSaga);
}
